import { MapPin, PhoneCall } from "lucide-react";
import { COMPANY } from "../lib/constants";
import { createWhatsAppLink } from "../lib/whatsapp";
import { LeadForm } from "./LeadForm";

export function Contact() {
  return (
    <section id="contato" className="section contact-section" data-testid="contact-section">
      <div className="contact-copy" data-testid="contact-copy">
        <span className="section-eyebrow" data-testid="contact-eyebrow">Contato imediato</span>
        <h2 data-testid="contact-title">Precisa de guincho agora em Arujá?</h2>
        <p data-testid="contact-description">Fale com a Auto Socorro Pedrinho pelo WhatsApp ou ligue agora.</p>
        <div className="contact-actions" data-testid="contact-actions">
          <a className="btn btn-whatsapp" href={createWhatsAppLink()} data-testid="contact-whatsapp-button">WhatsApp</a>
          <a className="btn btn-dark" href={COMPANY.phoneHref} data-testid="contact-phone-button"><PhoneCall size={18} /> Ligar agora</a>
        </div>
        <div className="address-card" data-testid="contact-address-card"><MapPin size={22} /> <span data-testid="contact-address-text">{COMPANY.address}</span></div>
      </div>
      <LeadForm />
    </section>
  );
}